<script lang="ts">
import { getWidgetFieldProps } from '@widgets/shared/compositions/field'
import { widgetFormFieldProps } from '@widgets/shared/components/fields/types'
import WidgetFieldContentEditor from '@widgets/shared/components/fields/WidgetFieldContentEditor.vue'
import type { WidgetAttachment } from '@widgets/shared/types'
import { defineComponent, h } from '@/composition/vue/compositionApi'

export default defineComponent({
  props: {
    ...widgetFormFieldProps,
    attachmentFieldName: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
    },
  },
  setup(props, context) {
    return () => {
      const fieldProps = getWidgetFieldProps(props.name!)
      const attachmentFieldProps = getWidgetFieldProps<WidgetAttachment[]>(props.attachmentFieldName)

      return h(WidgetFieldContentEditor, {
        ...fieldProps,
        ...context.attrs,
        placeholder: props.placeholder,
        attachments: attachmentFieldProps.modelValue,
      })
    }
  },
})
</script>
